import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import SnackbarContext from "../../../Context/SnackbarContext";
import {editDocument} from "../../../Services/DocumentManagement/DocumentService";
import DocumentForm from "../../../Components/Forms/Pages/Document/Document/DocumentForm";
import {getDocumentCategories} from "../../../Services/DocumentManagement/DocumentCategoryService";
import {getDocumentStatuses} from "../../../Services/DocumentManagement/DocumentStatusService";

const formRules = {
    'name': {required: true},
}

const EditDocument = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? props.data[0] : undefined
    });
    const {data, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [documentStatus, setDocumentStatus] = useState([]);
    const [documentCategory, setDocumentCategory] = useState([]);

    useEffect(() => {
        setDrawerTitle(strings.pages.document.document.editDocument.pageTitle);
    });

    useEffect(() => {
        fetchDocumentCategories();
        fetchDocumentStatuses();
    }, [])

    const fetchDocumentCategories = (term = '') => {
        getDocumentCategories({term}).then(response => {
            if (!response || !response.ok){
                return;
            }

            setDocumentCategory(response.data.result);
        })
    }

    const fetchDocumentStatuses = (term = '') => {
        getDocumentStatuses({term}).then(response => {
            if (!response || !response.ok){
                return;
            }

            setDocumentStatus(response.data.result);
        })
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        editDocument(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <DocumentForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue} onChangeDocumentCategoryFilter={fetchDocumentCategories}
                errors={errors} data={data} form={form} onChangeDocumentStatusFilter={fetchDocumentStatuses}
                documentCategories={documentCategory} documentStatuses={documentStatus}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default EditDocument;